import { TileIndex } from "../types";
import { BALLPUSH_TESTCASE } from "./ballPushTestCase";

// Import all levels from individual files
import { ANNOYING_CAT } from "./levels/annoyingCat";
import { ATTACK } from "./levels/attack";
import { BEE_CAREFUL } from "./levels/beeCareful";
import { LEVEL_1 } from "./levels/bombChamber";
import { BOMB_DIFFUSER_LEVEL } from "./levels/bombDiffuser";
import { HARD_LEVEL } from "./levels/bugGauntlet";
import { CHAIN_REACTION } from "./levels/chainReaction";
import { DONT_GO_UP_LEVEL } from "./levels/dontGoUp";
import { LEVEL_2 } from "./levels/doorDash";
import { GO_UP } from "./levels/goUp";
import { IT_FLOATS } from "./levels/itFloats";
import { LOGIC_PUZZLE } from "./levels/logicPuzzle";
import { NUTS_AND_BOLTS_LEVEL } from "./levels/nutsAndBolts";
import { O_LEVEL } from "./levels/oLevel";
import { ORDER_MATTERS_LEVEL } from "./levels/orderMatters";
import { PLANNER_10 } from "./levels/planner10";
import { PRESS_AND_HOLD_LEVEL } from "./levels/pressAndHold";
import { PUSH_TEST } from "./levels/pushTest";
import { RUN_LEVEL_1 } from "./levels/runLevel1";
import { RUN_LEVEL_2 } from "./levels/runLevel2";
import { SURPRISE_LEVEL } from "./levels/surprise";
import { TEST_LEVEL } from "./levels/testLevel";
import { TURN_LEVEL } from "./levels/turn";
import { TUTORIAL_LEVEL } from "./levels/tutorial";
import { TWO_BEES } from "./levels/twoBees";
import { WATER_LEVEL } from "./levels/waterWorld";

export type LevelData = {
  name: string;
  tiles: TileIndex[][];
  hint?: string;
  password?: string;
};

// Tile types:
// 0 = white tile (passable)
// 1 = black tile (wall)
// 2 = star (collectible)
// 3 = bomb (deadly)
// 4 = green key
// 5 = red key
// 6 = orange key
// 7 = blue key
// 8 = green door
// 9 = red door
// 10 = orange door
// 11 = blue door
// 12 = player start
// 13 = sand (disappears when touched)
// 14 = bug (enemy, moves randomly, kills player)
// 15 = exit (finish level)

export const LEVELS: LevelData[] = [
  {
    // keys, doors, stars, sand, exit
    name: "Tutorial",
    tiles: TUTORIAL_LEVEL,
    hint: "Collect all the stars and go through the green pipe.",
    password: "RDOT",
  },
  {
    // water blocks, water, bees
    name: "Water World",
    tiles: WATER_LEVEL,
    hint: "Push blocks into the water to create a path, or find the flippers.",
    password: "SWIM",
  },
  {
    // bombs
    name: "Order Matters",
    tiles: ORDER_MATTERS_LEVEL,
    hint: "Collect items in the correct order to proceed.",
    password: "ORDR",
  },

  {
    // arrow tiles
    name: "Surprise!",
    tiles: SURPRISE_LEVEL,
    hint: "",
    password: "OOPS",
  },
  {
    // buttons and button-doors, blocks hold down buttons
    name: "Press and Hold",
    tiles: PRESS_AND_HOLD_LEVEL,
    hint: "Press the button to open the door.",
    password: "HOLD",
  },
  /*   {
    name: "Key Maze",
    tiles: TEST_LEVEL,
    hint: "Collect keys in the right order to unlock all doors.",
    password: "KEYS",
  }, */
  {
    // bees
    name: "Bee Careful",
    tiles: BEE_CAREFUL,
    hint: "Avoid the bees and reach the exit.",
    password: "BEES",
  },
  {
    // bombs kill bees
    name: "Bomb Diffuser",
    tiles: BOMB_DIFFUSER_LEVEL,
    hint: "Bee, meet bomb",
    password: "BOMB",
  },
  {
    // cat, outrunning enemies
    name: "Annoying Cat",
    tiles: ANNOYING_CAT,
    hint: "This cat is annoying!",
    password: "ACAT",
  },
  {
    // bugs, boots, flippers
    name: "Fancy shoes",
    tiles: NUTS_AND_BOLTS_LEVEL,
    hint: "Green boots for arrows, flippers for water",
    password: "BOOT",
  },
  {
    // blocks on arrows
    name: "Don't Go Up",
    tiles: DONT_GO_UP_LEVEL,
    hint: "Get the blue key",
    password: "DOWN",
  },
  {
    // two bees level
    name: "Two Bees",
    tiles: TWO_BEES,
    hint: "Use bombs to eliminate the bees and reach the exit.",
    password: "TBEE",
  },
  {
    // outrunning cats
    name: "Run! #1",
    tiles: RUN_LEVEL_1,
    hint: "Keep moving to avoid the cats.",
    password: "RUN1",
  },
  {
    // balls, balls press buttons
    name: "It Floats",
    tiles: IT_FLOATS,
    hint: "Balls float across water",
    password: "BALL",
  },
  {
    // balls, balls press buttons
    name: "It Floats",
    tiles: IT_FLOATS,
    hint: "Balls float across water",
    password: "BALL",
  },
  {
    name: "Press the button",
    tiles: O_LEVEL,
    hint: "Use the walls to guide the ball in the correct path to hit the button.",
    password: "WALL",
  },
  {
    name: "Chain Reaction",
    tiles: CHAIN_REACTION,
    hint: "Create a chain reaction to reach the exit.",
    password: "CHAI",
  },
  {
    name: "Attack!",
    tiles: ATTACK,
    hint: "Use the balls to kill the bees.",
    password: "ATCK",
  },
  {
    // arrow buttons
    name: "Turn",
    tiles: TURN_LEVEL,
    hint: "Turn the arrow tiles using the green button.",
    password: "TURN",
  },
  {
    name: "Always go up in the next level",
    tiles: PLANNER_10,
    hint: "Balls kill bees",
    password: "PLAN",
  },
  { name: "The Maze", tiles: GO_UP, hint: "Always go up", password: "GOUP" },
  {
    name: "Run! #2",
    tiles: RUN_LEVEL_2,
    hint: "Keep moving to avoid the bugs.",
    password: "RUN2",
  },
  {
    name: "Hard Logic Puzzle",
    tiles: LOGIC_PUZZLE,
    hint: "Solve the puzzle to reach the exit.",
    password: "HARD",
  },
  {
    // maybe sort of boring
    name: "Door Dash",
    tiles: LEVEL_2,
    hint: "Navigate through the doors in sequence.",
    password: "DASH",
  },
  {
    name: "Bomb Chamber",
    tiles: LEVEL_1,
    hint: "The green door hides a star, but beware the bombs!",
    password: "BOOM",
  },
  {
    name: "Bug Gauntlet",
    tiles: HARD_LEVEL,
    hint: "Bugs move randomly. Time your movements carefully.",
    password: "BUGS",
  },
  {
    name: "Test Level",
    tiles: TEST_LEVEL,
    hint: "Just a small test level.",
    password: "TEST",
  },
  {
    name: "Push Test",
    tiles: PUSH_TEST,
    hint: "Testing pushing water blocks with momentum.",
    password: "PUSH",
  },
  {
    name: "Ball Push Test Case",
    tiles: BALLPUSH_TESTCASE,
    hint: "Testing pushing balls with momentum.",
    password: "BPTC",
  }
];

export function findLevelByPassword(password: string): number {
  const upperPassword = password.toUpperCase();
  return LEVELS.findIndex(
    (level) => level.password?.toUpperCase() === upperPassword
  );
}
